/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateNoticeDto } from '../../models/create-notice-dto';
import { NoticeDto } from '../../models/notice-dto';

export interface NoticeControllerCreateV1$Params {
      body: CreateNoticeDto
}

export function noticeControllerCreateV1(http: HttpClient, rootUrl: string, params: NoticeControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<NoticeDto>> {
  const rb = new RequestBuilder(rootUrl, noticeControllerCreateV1.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<NoticeDto>;
    })
  );
}

noticeControllerCreateV1.PATH = '/api/v1/notice';
